/*
Render purchase order form
*/
import './style.styl';

angular
  .module(__filename, [
    require('local_modules/directives/purchase_order_header').default,
    require('local_modules/directives/purchase_order_summary').default,
  ])

  .directive(
    'poForm',
    ngInject(() => ({
      restrict: 'E',
      scope: {
        form: '=',
        foodhub: '=',
        onChangeAction: '=',
      },
      template: require('./template'),
      controllerAs: 'ctrl',
      bindToController: true,
      controller: ngInject(function(activeDropoffWindowOptions) {
        this.activeDropoffWindowOptions = activeDropoffWindowOptions;
        /*
          ACTIONS
        */
        this.actions = [
          {
            type: 'edit',
            label: 'Edit Purchase Order',
            isSelectable: () =>
              this.form != null ? this.form.canPerformAction('edit') : undefined,
          },
          {
            type: 'confirm',
            label: 'Confirm Purchase Order',
            isSelectable: () =>
              this.form != null ? this.form.canPerformAction('confirm') : undefined,
          },
          {
            type: 'unconfirm',
            label: 'Unconfirm Purchase Order',
            isSelectable: () =>
              this.form != null ? this.form.canPerformAction('unconfirm') : undefined,
          },
          {
            type: 'cancel',
            label: 'Cancel Purchase Order',
            isSelectable: () =>
              this.form != null ? this.form.canPerformAction('cancel') : undefined,
          },
          {
            type: 'clone',
            label: 'Clone Purchase Order',
            isSelectable: () =>
              this.form != null ? this.form.canPerformAction('clone') : undefined,
          },
        ];

        return this;
      }),
    })),
  );

export default __filename;
